import { useAwardPoints } from "../../hooks/useAwardPoints";

const VideoWatched = ({ achievementId, collection, id, allowDuplicates = false, validityCheck = true, showModalOverride }) => {
    useAwardPoints(achievementId, collection, id, allowDuplicates, validityCheck,  showModalOverride);

    return null;
}

export default VideoWatched;